import React from 'react';
import type { FC } from 'react';
import { SiteProvider } from '../../site/index.js';
import { AppDev } from './app-flow/AppDev.js';

export const AppDevFlow: FC = () => {
  return (
    <SiteProvider>
      <AppDev />
    </SiteProvider>
  );
};
